import React from "react";
import { Navigate } from "react-router-dom";
import { useAccount } from "@/contexts/AccountContext";

interface Props {
  children: React.ReactNode;
}

const AdminRoute: React.FC<Props> = ({ children }) => {
  const { isAdmin, isLoading } = useAccount();

  if (isLoading) return null;
  if (!isAdmin) return <Navigate to="/home" replace />;

  return <>{children}</>;
};

export default AdminRoute;
